/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-07-24 21:13:51
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-11-25 13:25:30
 * @FilePath: \betdoce-web\src\utils\auth.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { store } from "@/store";
import { loginEvent, SHOW_LOGIN_EVENT } from "@/api/request";
import { useDevice } from "@/composables/useDevice";

const { isMobile } = useDevice();
isMobile.value = window.innerWidth <= 768;

// Token 相关操作
export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const setToken = (token: string): void => {
  localStorage.setItem("token", token);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refresh_token");
};

export const setRefreshToken = (refreshToken: string): void => {
  localStorage.setItem("refresh_token", refreshToken);
};

export const removeToken = (options?: { clearInviteCode?: boolean }): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("isNew");
  localStorage.removeItem("isLogin");
  if (options?.clearInviteCode) {
    localStorage.removeItem("inviteCode");
  }
  localStorage.removeItem("assistanceTimer");
  localStorage.removeItem("checkRebate");
  removeUserInfo();
};

export const removePddActivityData = (): void => {
  sessionStorage.removeItem("pddActivityData");
};

// 用户信息相关操作
export const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

export const setUserInfo = (userInfo: object) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

export const removeUserInfo = () => {
  localStorage.removeItem("userInfo");
};

// 登录状态检查
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

// 检查用户是否绑定了手机号
export const hasPhoneBound = (): boolean => {
  const userInfo = getUserInfo();
  return userInfo?.user?.account_name ? true : false;
};

// 存储目标路由
let targetRoute: string | null = null;

// 检查是否需要登录
export const checkAuth = (to: any, from: any) => {
  console.log("checkAuth", isAuthenticated(), to, from);
  if (!isAuthenticated() && to.meta?.requiresAuth) {
    console.log("checkAuth - user not authenticated");
    // 存储目标路由
    targetRoute = to.fullPath;
    console.log(isMobile.value);
    if (isMobile.value) {
      loginEvent.dispatchEvent(new Event(SHOW_LOGIN_EVENT));
      if (!from.name) {
        return "/home";
      }
      return false;
    } else {
      loginEvent.dispatchEvent(new Event(SHOW_LOGIN_EVENT));
      return "/home";
    }
  }

  // 检查游客身份访问受限页面
  if (isAuthenticated()) {
    const userInfo = getUserInfo();
    console.log("userInfo for guest check:", userInfo);
    const isGuest = !userInfo?.user.phone; // 没有手机号的用户是游客

    // 定义需要绑定手机号的页面路径
    const restrictedPaths = [
      // "/records",
      // "/m/records",
      "/withdraw",
      "/m/withdraw",
      "/connection",
      "/m/connection",
      "/aposta",
      "/m/aposta",
      "/invite",
      "/cash-back",
      "/m/cash-back",
      "/m/invite",
      "/Atividades-Pinduoduo",
      "/m/Atividades-Pinduoduo",
      "/m/Opinion",
      "/Opinion",
    ];

    if (isGuest && restrictedPaths.includes(to.path)) {
      console.log("Guest user trying to access restricted path:", to.path);
      // 存储目标路由
      targetRoute = to.fullPath;
      // 触发手机号绑定提示事件

      if (isMobile.value) {
        window.dispatchEvent(new CustomEvent("show-join-us"));
      } else {
        window.dispatchEvent(
          new CustomEvent("show-phone-binding", {
            detail: { targetRoute: to.fullPath },
          })
        );
      }
      return false; // 阻止导航
    }
  }

  return true;
};

// 获取并清除目标路由
export const getAndClearTargetRoute = () => {
  const route = targetRoute;
  targetRoute = null;
  return route;
};

// 登出操作
export const logout = () => {
  removeToken({ clearInviteCode: true });
  removeUserInfo();
  store.commit("auth/CLEAR_AUTH");
  window.location.href = "/home";
};
